import { CANVAS_SELECTORS } from "../constants/tools";
/**
 * Obtiene el elemento canvas de Excalidraw
 */
export const getExcalidrawCanvas = () => {
    return document.querySelector(CANVAS_SELECTORS.EXCALIDRAW_CANVAS);
};
/**
 * Verifica si un elemento está dentro del contenedor de Excalidraw
 */
export const isInsideExcalidraw = (element) => {
    return !!element.closest(CANVAS_SELECTORS.EXCALIDRAW_CONTAINER);
};
/**
 * Obtiene el botón de exportar imagen de Excalidraw
 */
export const getExportButton = () => {
    return document.querySelector(CANVAS_SELECTORS.EXPORT_BUTTON);
};
/**
 * Calcula la diferencia entre dos puntos
 */
export const calculateDelta = (current, origin) => {
    return {
        dx: current.x - origin.x,
        dy: current.y - origin.y
    };
};
/**
 * Valida si un tipo de archivo es una imagen válida
 */
export const isValidImageType = (fileType) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg", "image/gif", "image/webp"];
    return validTypes.includes(fileType);
};
